import { useConstantCallback } from './useConstantCallback';

export type ErrorHandler = (error: Error | unknown) => void;

export function useSentryExceptionHandler(): ErrorHandler {
  return useConstantCallback<ErrorHandler>((err) => {
    console.error(err);
  });
}
